import React from "react";

export function renderMarkdown(text = "") {
  const lines = text.split("\n");
  const elements = [];

  let inCodeBlock = false;
  let code = [];
  let key = 0;

  const renderInline = (text) => {
    const parts = text.split(/(\*\*.*?\*\*|`.*?`)/g);

    return parts.map((part, index) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        return (
          <strong key={index}>
            {part.slice(2, -2)}
          </strong>
        );
      }

      if (part.startsWith("`") && part.endsWith("`")) {
        return (
          <code
            key={index}
            style={{
              background: "#f5f5f5",
              padding: "2px 4px",
              borderRadius: 4,
              fontFamily: "monospace",
            }}
          >
            {part.slice(1, -1)}
          </code>
        );
      }

      return part;
    });
  };

  for (const line of lines) {
    if (line.startsWith("```")) {
      if (inCodeBlock) {
        elements.push(
          <pre
            key={key++}
            style={{
              background: "#f5f5f5",
              padding: 12,
              borderRadius: 6,
              overflowX: "auto",
            }}
          >
            <code>{code.join("\n")}</code>
          </pre>
        );
        code = [];
      }

      inCodeBlock = !inCodeBlock;
      continue;
    }

    if (inCodeBlock) {
      code.push(line);
    } else {
      elements.push(
        <React.Fragment key={key++}>
          {renderInline(line)}
          <br />
        </React.Fragment>
      );
    }
  }

  return elements;
}